<template>
  <div id="app">

    <div class="superglobal" id="superglobal">
        <div data-role="header" data-position="fixed" style="border-bottom: 0; height: 115px;">
          <div style="height:10px"></div>
          <div style="background-color: #ffffff;height:80px">

                  <a href=""><img src="./assets/logo_ferti.png" alt="Logo Fertiliser avec les produits organiques" class="logo-header" /></a>

                  <img src="./assets/logo_arvalis.png" alt="Logo ARVALIS - Institut du végétal" class="logo-arvalis-header" />
                  <img src="./assets/interreg.jpg" alt="Logo Interreg" class="logo-interreg2-header" />
                  <img src="./assets/UE.jpg" alt="Logo Interreg" class="logo-interreg-header" />

          </div>
          <div style="height:10px"></div>
          <div style="background-color: #087b7a;min-height:22px;">
            <div class="container" id="nav">
              <!--<div style="color:#fff;float:right;line-height:22px;font-size:1.1em"><a class="lien_ruban" href="">En savoir plus</a></div>-->
              <div style="width:300px;margin:auto;">
                <div style="float:left;">
                  <router-link :to="`/${$i18n.locale}`">{{ $t('nav.accueil') }}</router-link> |
                  <router-link :to="`/${$i18n.locale}/about`">{{ $t('nav.info') }}</router-link> | 
                </div>
                <LanguageSwitcher></LanguageSwitcher>
              </div>
            </div>
            <!--<LanguageSwitcher></LanguageSwitcher>-->
          </div>

        </div>
      <div class="global" id="global">

        <router-view class="contenu"/>
      </div>
      <footer class="site-footer">
        <img src="./assets/logo_arvalis.png" alt="Logo ARVALIS - Institut du végétal" style="width:210px" />
        <div class="lim-footer">
        <p style="text-align:center"><a href="http://arvalis.info/cguoad" target="blank" class="popup-link">CGU</a> | <router-link :to="`/${$i18n.locale}/contact`">{{ $t('nav.contact') }}</router-link> | <span v-html="$t('footer')"></span><br><br><img src="./assets/UE.jpg" alt="Logo UE" style="width:45px" /></p>
        </div>
      </footer>
    </div>


  </div>
</template>


<script>
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

export default {
  name: 'app',
  components: {
    LanguageSwitcher
  }
}
</script>


<style>
  @import './assets/arvalis.css';
</style>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


#nav a {
  color:#ffffff;
  text-decoration: none;
}

#nav a.router-link-exact-active {
  text-decoration: underline;
}
</style>
